module.exports = __webpack_public_path__ + "static/img/icon08.4c53650.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/culture/icon08.png
// module id = 71YC
// module chunks = 1